module.exports = __webpack_public_path__ + "static/media/male3.07cd15f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/male3.png
// module id = 896
// module chunks = 0